import type { OrganisationListItem } from '@repo/front-end-services';

/**
 * The organisation a twin BELONGS TO, from the organisation list: the twin's own `organisation_id`,
 * matched by `id` — never the operator's selected organisation, which for a TL_ADMIN opening
 * another organisation's twin is a different one. Null when the list holds no such organisation (it
 * returns only what the caller can see).
 *
 * One rule for the Equipment step's *Uploading to* target (`useTwinOrganisationName`) and the
 * Opening hours step's *Copy another twin* (`useOrganisationTwins`). Go Live's
 * `resolveActivationOrg` applies the same match but fails closed with a BID, a different contract,
 * and keeps its own.
 */
export const matchTwinOrganisation = (
  organisations: readonly OrganisationListItem[],
  organisationId: number,
): OrganisationListItem | null => organisations.find(o => o.id === organisationId) ?? null;
